import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
// import { AppContainer } from 'react-hot-loader'
import './index.css?v=1.1';
import App from './App'
import * as serviceWorker from './serviceWorker';

import configureStore, { history } from './store'

const store = configureStore()
window.helRoot = document.getElementById('root')

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>
  , window.helRoot);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA


// serviceWorker.register();
if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  })
}
